import { Trans, useLingui } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

import { ListAccessLimiterResponse, PermissionBit } from "../../../api";
import { AppModel } from "../../../app/app-model";
import { SimpleTable } from "../../../components/ui-kit/tables/simple-table";

export const LimitersRoute = observer(function LimitersRoute(props: {
  app: AppModel;
}) {
  const { t } = useLingui();
  const admin = props.app.requireAdminShit();
  const [limiters, setLimiters] = useState<ListAccessLimiterResponse>();

  useEffect(() => {
    const fetchTeams = async () => {
      const teams = await admin.api.getLimiters();
      setLimiters(teams);
    };
    void fetchTeams();
  }, [admin.api]);

  return limiters ? (
    <>
      <div className="flex flex-col items-center">
        <SimpleTable
          rows={limiters.limiters}
          countNoun={{
            singular: t`access limiter`,
            plural: t`access limiters`,
          }}
          columns={[
            {
              header1: <Trans>Limiting table</Trans>,
              cell: (item) => item.limiter_table,
            },
            {
              header1: <Trans>Limiter type</Trans>,
              cell: (item) => item.limiter_type,
            },
            {
              header1: <Trans>Limit particular permission</Trans>,
              cell: (item) =>
                item.limit_permission_bit != null
                  ? PermissionBit[item.limit_permission_bit]
                  : null,
            },
            {
              header1: <Trans>Limit particular username</Trans>,
              cell: (item) => item.limit_username,
            },
            {
              header1: <Trans>Limit whole table?</Trans>,
              cell: (item) => item.limit_whole_table,
            },
            {
              header1: <Trans>Allowed items</Trans>,
              cell: (item) =>
                item.allowed_items ? item.allowed_items.join(", ") : null,
            },
            {
              header1: <Trans>Forbidden items</Trans>,
              cell: (item) =>
                item.forbidden_items ? item.forbidden_items.join(", ") : null,
            },
          ]}
          long
        />
      </div>

      <br className="h-5" />

      <div className="max-w-[600px]">
        <span>
          <Trans>Note on limiters:</Trans>
        </span>
        <br className="h-5" />
        <p className="mt-4 mb-4">
          <Trans>
            List of access limiters to limit access to various realms of
            Seerlinq-DB. These limiters apply for users of{" "}
            <strong>Level 2</strong>, and exists in two flavours:
            <em>permission bit</em> (limit all users holding a particular
            permission) and <em>user</em> (limit specific user). They can work
            on any data table (diagnoses, medical data, medications, symptoms)
            and each limiter implements two lists: allowed and forbidden items.
            When chaining limiters (e.g., particular user is limited by
            permission-bit and user limiters at the same time), the priority
            goes user → permission bit. If, e.g., user limiter allows one item,
            but permission-bit limiter forbids it, it will be returned.
          </Trans>
        </p>
        <p className="mt-4 mb-4">
          <Trans>
            You can only list limiters here, for editing, deleting or adding,
            contact <strong>Admin</strong>
          </Trans>
        </p>
      </div>
    </>
  ) : null;
});
